import React, {Fragment} from 'react';
import {Activities, Goals, UI, Popup, InlineNumberFormat} from 'components';
import {modal, moment, useNamedSelector, useDrop} from 'helpers';
import {attach} from 'store/activities';
import {goals} from 'store';

export function Card(props) {
  const { Card } = UI;
  const { Checkbox } = props;
  const milestone = useNamedSelector('goals.goal', { id: props.id });
  const goal = useNamedSelector('goals.goal', { id: milestone?.parent_id });
  const { editable } = useNamedSelector('goals.details', { id: props.id });
  const onDrop = useDrop(attach, ({type, parentId}) => type === 'activity' && parentId != props.id);
  return (
    <Card {...props} {...milestone} onClick={editable ? modal(Goals.Milestones.EditForm, { goal, milestone }) : undefined} {...onDrop}>

      { Checkbox && <Checkbox {...props} /> }

      <Popup.Menu.Handle Menu={Menu} milestone={milestone} editable={editable} />

      <Card.Body>
        <Card.Text>{ milestone.name }</Card.Text>
        <Card.Note>{ milestone.note }</Card.Note>
        { milestone.target_value &&
          <Card.Note>
            <InlineNumberFormat value={milestone.target_value} unit={milestone.unit} />
          </Card.Note>
        }
      </Card.Body>

      { milestone.target_date &&
        <Card.Footer className="text-right">
          { moment.unix(milestone.target_date).format() }
        </Card.Footer>
      }

      { onDrop &&
        <Card.Dropzone>Drop here to link to this milestone</Card.Dropzone>
      }

    </Card>
  );
}

function Menu({ milestone }) {
  const goal = useNamedSelector('goals.goal', { id: milestone.parent_id });
  return (
    <Fragment>
      <Popup.Menu.Item icon="check" onClick={() => goals.dispatch.toggle({id: milestone.id })}>
        { milestone.status == 'Completed' ? 'Uncomplete' : 'Complete' }
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="pencil" onClick={modal(Goals.Milestones.EditForm, { milestone, goal })}>
        Edit
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="duplicate" onClick={() => goals.dispatch.duplicate({ id: milestone.id })}>
        Duplicate
      </Popup.Menu.Item>
      <Popup.Menu.Item icon="plus" onClick={modal(Activities.Single.EditForm, { milestone })}>
        Add Activity
      </Popup.Menu.Item>
      <Popup.Menu.Separator />
      <Popup.Menu.DeleteItem onConfirm={() => goals.dispatch.remove({id: milestone.id})}>
        Delete
      </Popup.Menu.DeleteItem>
    </Fragment>
  );
}

